import { Component, Input } from '@angular/core';
import { CardGroupBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-card-group',
  templateUrl: './mr-card-group.component.html',
  styleUrls: ['./mr-card-group.component.scss'],
})
export class MrCardGroupComponent extends MessageBlockBaseDirective {
  @Input() block!: CardGroupBlock;
}
